import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { scrollToId } from "@/context/SilverContext";
import { cn } from "@/lib/utils";

const LINKS = [
  { id: "how", label: "How it works" },
  { id: "audience", label: "Audience" },
  { id: "build", label: "Search your area" },
  { id: "talk", label: "Talk to Print" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => { setOpen(false); setTimeout(() => scrollToId(id), 50); };

  return (
    <header className="fixed inset-x-0 top-0 z-40 px-3 pt-3 sm:px-6 sm:pt-4">
      <motion.nav initial={{ y: -24, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} aria-label="Main"
        className={cn("mx-auto flex max-w-7xl items-center gap-3 rounded-full border py-2 pl-4 pr-2 transition-[background-color,border-color,box-shadow,backdrop-filter] duration-500 sm:pl-5",
          scrolled ? "border-white/10 bg-[rgba(12,30,16,0.72)] shadow-[0_20px_50px_-20px_rgba(0,0,0,0.6)] backdrop-blur-2xl" : "border-white/[0.06] bg-white/[0.03] backdrop-blur-md")}
        data-testid="site-header">
        <a href="/" className="flex shrink-0 items-center" data-testid="nav-logo"><img src="/brand/nichecom-wordmark-dark.png" alt="NicheCom" className="h-[18px] w-auto sm:h-5" /></a>
        <span className="hidden h-5 w-px bg-white/15 sm:block" aria-hidden="true" />
        <span className="hidden rounded-full border border-[#96C11F]/40 px-2.5 py-[3px] font-ui text-[9.5px] font-semibold tracking-[0.14em] text-[#C6EE5A] sm:inline-flex">AUDIENCE INTELLIGENCE</span>
        <div className="ml-auto hidden items-center gap-0.5 lg:flex">
          {LINKS.map((l) => (
            <button key={l.id} type="button" onClick={() => scrollToId(l.id)} className="rounded-full px-3.5 py-2 text-[13px] text-white/70 transition-colors hover:bg-white/5 hover:text-white" data-testid={`nav-link-${l.id}`}>{l.label}</button>
          ))}
          <Link to="/admin" className="rounded-full px-3.5 py-2 text-[13px] text-white/70 transition-colors hover:bg-white/5 hover:text-white" data-testid="nav-login-link">Login</Link>
        </div>
        <button type="button" className="btn-primary ml-auto !px-4 !py-2.5 text-[13px] lg:ml-2" onClick={() => scrollToId("build")} data-testid="nav-build-audience-btn">
          <span className="hidden sm:inline">Build an audience</span><span className="sm:hidden">Build</span> <ArrowRight className="h-4 w-4" />
        </button>
        <button type="button" className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-white lg:hidden" onClick={() => setOpen(true)} aria-label="Open menu" data-testid="nav-menu-btn">
          <Menu className="h-4 w-4" />
        </button>
      </motion.nav>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-[86%] border-l border-white/10 !bg-[rgba(12,30,16,0.96)] p-8 text-white backdrop-blur-2xl" data-testid="mobile-menu">
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <p className="eyebrow">NicheCom Print · Audience Intelligence</p>
          <nav className="mt-8 flex flex-col gap-1">
            {LINKS.map((l) => (
              <button key={l.id} type="button" onClick={() => go(l.id)} className="py-3 text-left text-2xl font-bold tracking-[-0.03em] text-white/85 hover:text-white" data-testid={`mobile-nav-${l.id}`}>{l.label}</button>
            ))}
            <Link to="/admin" className="py-3 text-2xl font-bold tracking-[-0.03em] text-white/60" data-testid="mobile-nav-login">Login</Link>
          </nav>
          <button type="button" className="btn-primary mt-10 w-full" onClick={() => go("build")} data-testid="mobile-nav-build-btn">Build an audience <ArrowRight className="h-4 w-4" /></button>
        </SheetContent>
      </Sheet>
    </header>
  );
}
